import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import {
  PartnerBankJourneyStage,
  partnerBankJourneyStageLabel,
} from '@interfaces/partners/responses/partner-bank-journey.response';
import { SharedModule } from '@src/app/shared/shared.module';
import { DealBankJourneyStore } from '@features/dashboard/commercial/pages/deal-detail/components/bank-journey/deal-bank-journey.store';

/** Cor da etiqueta de cada etapa do banco: navy no começo, azul enquanto o banco analisa, verde no sim, vermelho no não. */
const STAGE_TONE: Record<PartnerBankJourneyStage, 'navy' | 'info' | 'success' | 'danger'> = {
  Presentation: 'navy',
  DocumentSubmission: 'info',
  CreditAnalysis: 'info',
  Rejected: 'danger',
  Approved: 'success',
  Disbursement: 'success',
};

/**
 * Cartão **Bancos da operação** na coluna lateral da Visão geral do deal (card 3707): a lista curta dos bancos do
 * deal (logo, nome, valor, comentários e a etapa em etiqueta). Clicar num banco abre os comentários; o link leva à
 * visão Jornada nos bancos do cabeçalho (card 3752; até ali, aba Bancos), com o quadro completo.
 *
 * O dado é o do `DealBankJourneyStore` da tela, o mesmo da aba; a tela só mostra o cartão com `unlocked`.
 */
@Component({
  selector: 'app-deal-bank-journey-card',
  standalone: true,
  imports: [CommonModule, SharedModule],
  templateUrl: './deal-bank-journey-card.component.html',
  styleUrl: './deal-bank-journey-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DealBankJourneyCardComponent {
  protected readonly store = inject(DealBankJourneyStore);

  /** "Ver todos os bancos": leva à visão dos bancos do cabeçalho (card 3752). */
  readonly viewAll = output<void>();

  protected readonly stageLabel = partnerBankJourneyStageLabel;

  protected stageTone(stage: PartnerBankJourneyStage): string {
    return STAGE_TONE[stage] ?? 'navy';
  }
}
